import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

function CheckBirthYear() {
  const { isAuthenticated, account } = useSelector((state) => state.auth);

  if (isAuthenticated && (account.birthYear === '' || account.birthYear === null)) {
    return <Navigate to="/profile" />;
  }
}

export default CheckBirthYear;
